function u(e,o){const s={},l=Object.keys(e);for(let t=0;t<l.length;t++){const n=l[t],r=e[n];s[n]=o(r,n,e)}return s}export{u as mapValues};
